(function() { window.GUID_1e9bb04a_cc83_4b4c_b169_2285569d4537 = { getGuid: function() { return "1e9bb04a-cc83-4b4c-b169-2285569d4537"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PlayerFeatureAdvertisement extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.updateAppUserDatas = () => {
                    return new Promise((resolve, reject) => {
                        try {
                            const data = this.AppUserDatasToUpdate.join(":");
                            const updateAppUserDatasUrl = CS.Url.CSUrl("InsertAppUserDatas");
                            CS.Ajax.Post(updateAppUserDatasUrl, {
                                data,
                            }, (response) => {
                                resolve(response);
                            });
                        }
                        catch (error) {
                            console.error("There was an error updating the AppUserDatas.");
                            reject(error);
                        }
                    });
                };
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            get FeatureId() {
                return this.featureId;
            }
            get AppUserDatasToUpdate() {
                return this.appUserDatasToUpdate;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.featureId = params[1];
                this.appUserDatasToUpdate = params[2];
            }
            OnBindEvents() {
                this.$Control.offon("click.playerfeatureadvertisement", this.onClick.bind(this));
            }
            OnDispose() { }
            OnControlRendered() { }
            onClick(e) {
                console.log("PlayerFeatureAdvertisement.onClick");
                const url = $(e.currentTarget).data("url");
                if (url) {
                    if (this.AppUserDatasToUpdate) {
                        this.updateAppUserDatas()
                            .then((response) => {
                            CS.Nav.Go(url);
                        })
                            .catch((error) => {
                            console.error(error);
                            CS.Nav.Go(url);
                        });
                    }
                }
            }
        }
        Controls.PlayerFeatureAdvertisement = PlayerFeatureAdvertisement;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=player-feature-advertisement.js.map
